const pageTitles: { [key: string]: string } = {
    "/analytics": "Analytics",
    "/reports" : "Reports",
    "/team": "Teams",
    "/branding": "Branding",
    "/clients" : "Clients",
    "/profile" : "Profile",
    "/user-list" : "User List",
    "/add-edit-user" : "Add Edit User",
    "/orders" : "Orders",
    "/invoice" : "Invoice",
    "/proposals" : "Proposals",
    "/view_proposal" : "Proposal",
    "/corporate-info" : "Corporate Info",
    "/billing" : "Billing",
    "/email-reports" : "Email Reports"
  }; 

  export default pageTitles;
